import { textUtil } from '@cmg/common';

import type { InvestorFirmGridFilterInput } from '../../../../graphql';
import { RolodexRecordStatus } from '../../../../graphql';
import { serializeFirmKey } from '../../../util/rolodex/firm-key-type.util';
import { InvestorFirmSearch_InvestorFirmGridPartsFragment } from './graphql';
import { InvestorFirmOption } from './InvestorFirmSearch';

export const getInvestorFirmSearchTextFilter = (
  searchText: string
): InvestorFirmGridFilterInput | undefined =>
  searchText
    ? {
        or: [
          { name: { contains: searchText } },
          { firmKey: { contains: searchText } },
          { linkedCmgEntityKey: { contains: searchText } },
          { linkedCmgEntityName: { contains: searchText } },
        ],
      }
    : undefined;

export const getInvestorFirmOptions = (
  firms: readonly InvestorFirmSearch_InvestorFirmGridPartsFragment[],
  fallbackToFirmKey: boolean
) => {
  return firms
    .filter(investor => investor.status !== RolodexRecordStatus.Deleted)
    .map<InvestorFirmOption>(investor => {
      const location = investor.address1 || investor.address2;

      return {
        value:
          investor.linkedCmgEntityKey ?? (fallbackToFirmKey ? serializeFirmKey(investor) : null),
        label: investor.name,
        firmType: investor.firmType,
        firmKey: investor.firmKey ? textUtil.sanitizeWhiteSpaces(investor.firmKey) : null,
        firmId: investor.id,
        location: location ? textUtil.sanitizeWhiteSpaces(location) : null,
        status: investor.status,
        salesCoverageNames:
          investor.salesCoverage?.items
            ?.map(item => item.employeeName)
            .filter((name): name is string => !!name) ?? [],
        salesCoverageCount: investor.salesCoverage?.totalCount ?? 0,
      };
    });
};
